/* Melrose: mirror Seal Subscriptions' selected-plan price into the theme price block.
   Seal renders the correct live price inside its own widget (.sls-price) and updates it
   on toggle, but it does not write into the theme price element on products that carry a
   compare-at price - so those pages showed stale Liquid values. This copies the selected
   option's price (and its compare-at) into .price__regular and marks the block synced so
   the CSS can hide the stale .price__sale. */
(function () {
  if (window.__mePriceSync) return;
  window.__mePriceSync = true;

  var timer = null;

  function txt(node) { return node ? node.textContent.replace(/\s+/g, ' ').trim() : ''; }

  /* nearest ancestor of the checked plan radio that owns a Seal price */
  function selectedScope() {
    var radios = [].filter.call(
      document.querySelectorAll('input[type="radio"]'),
      function (r) { return r.checked && r.closest('[class*="sls-"]'); }
    );
    /* Seal renders more than one widget instance; prefer a visible one */
    var checked = radios.filter(function (r) { return r.offsetParent; })[0] || radios[0];
    if (!checked) return null;
    var node = checked;
    for (var i = 0; i < 8 && node.parentElement; i++) {
      node = node.parentElement;
      if (node.querySelector('.sls-price .seal-money')) return node;
    }
    return null;
  }

  function mainPriceBlocks() {
    return [].filter.call(document.querySelectorAll('.price'), function (p) {
      if (p.closest('.card, .card-wrapper, .product-card, .complementary-products, li')) return false;
      return !!p.querySelector('.price__regular .price-item--regular');
    });
  }

  function sync() {
    var scope = selectedScope();
    if (!scope) return;
    var current = txt(scope.querySelector('.sls-price .seal-money'));
    var compare = txt(scope.querySelector('.sls-original-price .seal-money'));
    if (!current) return;

    mainPriceBlocks().forEach(function (p) {
      var regular = p.querySelector(
        '.price__regular .price-item--regular:not(.price__compare-inline)');
      if (!regular) return;
      if (txt(regular) !== current) regular.textContent = current;

      var struck = p.querySelector('.price__compare-inline');
      if (struck) {
        if (compare && compare !== current) {
          if (txt(struck) !== compare) struck.textContent = compare;
          struck.style.display = '';
        } else {
          struck.textContent = '';
          struck.style.display = 'none';
        }
      }
      p.classList.add('price--seal-synced');
    });
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(sync, 120); }

  document.addEventListener('change', schedule, true);
  document.addEventListener('click', schedule, true);
  if (window.MutationObserver) {
    new MutationObserver(schedule).observe(document.documentElement,
      { subtree: true, childList: true, characterData: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  }
  schedule();
})();
